export const customFetch: Window['fetch'] = (requestInfo: RequestInfo, requestInit: RequestInit | undefined) => {
  const newRequestInit: RequestInit = { ...requestInit };
  const newHeaders = new Headers(requestInit?.headers);

  newHeaders.set('content-language', 'en');

  newRequestInit.headers = newHeaders;

  return fetch(requestInfo, newRequestInit);
};